import { ingestAPIObject } from "../utils/api";
export class RanchDTO {
    constructor(jsonData) {
        ingestAPIObject(this, jsonData);
    }
    get fullName() {
        if (this.growerName) {
            return `${this.name} (${this.growerName})`;
        }
        return this.name;
    }
}
